// The Achiziții module inside the DocFlow shell (Legea nr. 98/2016, HG nr. 395/2016): the annual programme (PAAP) and its annex, the
// referate de necesitate, the investment objectives, the versions, the annual strategy and the dossier of every purchase (#/achizitii/...).
// Every user may write referate and sees the committees he sits on; the programme is for the procurement roles, ALOP and the administrator.
import React, { useEffect, useState } from 'react';
import { api } from '../api';
import { navigate, useAuth } from '../store';
import { Icon } from '../ui/Icon';
import { isAchMember } from './types';
import { ProgramPage } from './Plan';
import { PositionPage } from './Position';
import { CommitteesPage, NeedsPage, ObjectivesPage, SettingsPage, StrategyPage, VersionsPage } from './Pages';

/** Everybody can open the module (referate, committees); the programme itself is for the members. */
export function hasAchizitii(_roles: string[]) { return true; }

export const ACH_TITLES: Record<string, string> = { plan: 'Programul anual al achizițiilor publice', position: 'Dosarul achiziției', needs: 'Referate de necesitate', objectives: 'Obiective de investiții',
  versions: 'Versiunile programului', strategy: 'Strategia anuală de achiziție', committees: 'Comisiile mele de evaluare', settings: 'Setări achiziții' };

type NavItemFn = (p: { icon: string; label: string; active: boolean; onClick: () => void; count?: number; alert?: boolean; title?: string }) => React.ReactElement;

export function AchNav({ page, NavItem }: { page: string; NavItem: NavItemFn }) {
  const { isAdmin, user } = useAuth();
  const member = isAchMember(user!.roles);
  const [b, setB] = useState({ needs: 0, warn: 0, committees: 0 });
  useEffect(() => {
    const load = () => {
      if (member) api.get<any>('/api/achizitii/overview?year=' + new Date().getFullYear()).then(o => setB(x => ({ ...x, needs: o.needs.submitted, warn: o.deadlines.filter((t: any) => t.overdue).length }))).catch(() => {});
      api.get<any[]>('/api/achizitii/committees/mine').then(l => setB(x => ({ ...x, committees: l.filter(c => !c.declaredAt).length }))).catch(() => {});
    };
    load();
    window.addEventListener('ach:changed', load);
    return () => window.removeEventListener('ach:changed', load);
  }, []);
  return <>
    <div className="nav-section">Planificare</div>
    {member && <NavItem icon="clipboard" label="Programul anual" count={b.warn || undefined} alert={b.warn > 0} title="PAAP și anexa achizițiilor directe" active={page === 'plan' || page === 'position'} onClick={() => navigate('/achizitii/plan')} />}
    <NavItem icon="file" label="Referate" title="Referate de necesitate" count={b.needs || undefined} active={page === 'needs'} onClick={() => navigate('/achizitii/needs')} />
    {member && <NavItem icon="building" label="Obiective de investiții" active={page === 'objectives'} onClick={() => navigate('/achizitii/objectives')} />}
    {member && <NavItem icon="book" label="Strategia anuală" active={page === 'strategy'} onClick={() => navigate('/achizitii/strategy')} />}
    {member && <NavItem icon="layers" label="Versiuni PAAP" active={page === 'versions'} onClick={() => navigate('/achizitii/versions')} />}
    <div className="nav-section">Proceduri</div>
    <NavItem icon="users" label="Comisiile mele" count={b.committees || undefined} alert={b.committees > 0} active={page === 'committees'} onClick={() => navigate('/achizitii/committees')} />
    {member && <NavItem icon="report" label="Rapoarte" active={page === 'reports'} onClick={() => navigate('/reports?m=ACH')} />}
    <NavItem icon="users" label="Delegări" active={page === 'delegations'} onClick={() => navigate('/delegations')} />
    {isAdmin && <><div className="nav-section">Configurare</div><NavItem icon="settings" label="Setări achiziții" active={page === 'settings'} onClick={() => navigate('/achizitii/settings')} /></>}
  </>;
}

export function AchContent({ parts }: { parts: string[] }) {
  const { isAdmin, user } = useAuth();
  const member = isAchMember(user!.roles);
  const page = parts[1] || (member ? 'plan' : 'needs');
  useEffect(() => { if (!parts[1]) navigate('/achizitii/' + page); }, [parts[1]]);
  const restricted = ['plan', 'objectives', 'strategy', 'versions'].includes(page) && !member;
  if (restricted) return <div className="empty"><Icon name="lock" /><h3>Programul anual este disponibil compartimentului de achiziții, conducerii și utilizatorilor ALOP</h3><p>Puteți întocmi referate de necesitate și vedea comisiile din care faceți parte.</p></div>;
  return <>
    {page === 'plan' && <ProgramPage />}
    {page === 'position' && parts[2] && <PositionPage key={parts[2]} id={Number(parts[2])} />}
    {page === 'needs' && <NeedsPage />}
    {page === 'objectives' && <ObjectivesPage />}
    {page === 'versions' && <VersionsPage />}
    {page === 'strategy' && <StrategyPage />}
    {page === 'committees' && <CommitteesPage />}
    {page === 'settings' && isAdmin && <SettingsPage />}
  </>;
}
